module.exports = __webpack_public_path__ + "static/img/14000376.efa9f15c.png";